<template>
  <img :src="data.iconUrl" :alt="data.iconUrl" :width="data.width" :height="data.height"/>
</template>

<script>
export default {
  name: 'TextPart',
  props: {
    data: Object,
  },
};
</script>
